// extracted by mini-css-extract-plugin
export default {"rotate":"setPageBtn_rotate__za1iP","btn":"setPageBtn_btn__yh9t0","btn_disabled":"setPageBtn_btn_disabled__7Rq+w"};